export const getDataTypeJson = (json) => {
  return typeof json === 'string' ? JSON.parse(json) : json;
};